export const scrollToSwitcherBlock = () => {
  const switcherBlock = document.getElementById("switcher_content")
  if (switcherBlock) {
    const elementOffsetTop = switcherBlock.offsetTop
    const scrollPosition = elementOffsetTop - 200
    window.scrollTo({
      top: scrollPosition,
      behavior: "smooth",
    })
  }
}
